import React, { Suspense } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useAffiliateAuth } from "../../contexts/AffiliateAuthContext";
import { LogOut, TrainFront } from "lucide-react";

export default function AffiliateLayout() {
  const { token, partner, loading, logout } = useAffiliateAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <p className="text-slate-400 text-sm">Loading Referral Partner dashboard…</p>
      </div>
    );
  }
  if (!token) {
    return <Navigate to="/affiliate/login" state={{ from: location.pathname }} replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-[#0F1B2E] text-white sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center">
              <TrainFront className="w-5 h-5 text-[#0F1B2E]" strokeWidth={2.4} />
            </div>
            <div>
              <p className="font-extrabold leading-none text-sm">Referral Partner Dashboard</p>
              <p className="text-[10px] uppercase tracking-widest text-slate-400">Train Driver Foundation</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <p className="text-xs text-slate-300 truncate max-w-[180px]">{partner?.name || partner?.email}</p>
            <button
              onClick={logout}
              className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs bg-white/10 hover:bg-[#E63B2E] transition-colors"
            >
              <LogOut className="w-3.5 h-3.5" /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-5 py-8">
        <Suspense fallback={<div className="flex items-center justify-center min-h-[40vh]"><div className="w-10 h-10 border-4 border-slate-200 border-t-[#E63B2E] rounded-full animate-spin" /></div>}>
          <Outlet />
        </Suspense>
      </main>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
